<ideal-product-listing-layout [floatHeader]="floatHeader()">
  @if (!forceGridView()) {
    <div header class="view-container">
      <mat-button-toggle-group [value]="view()" (valueChange)="setView($event)" aria-label="View mode">
        <mat-button-toggle value="grid"><mat-icon>grid_view</mat-icon></mat-button-toggle>
        <mat-button-toggle value="list"><mat-icon>list</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }
  @if (hasResults()) {
    <ideal-product-result-list [ids]="resultIds()" [view]="effectiveView()" />
    <ideal-load-more [mode]="loadMoreMode()" [loading]="loading()" [disabled]="!hasMore()" (loadMore)="onLoadMore()" />
  }
</ideal-product-listing-layout>
